module.exports = __webpack_public_path__ + "static/media/cocktail.3c451d90.svg";